/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';

import { BUSINESS_TYPE } from '@commons/constants';
import { WindowContext } from '@providers/WindowProvider';
import { isNullOrUndefined } from '@utils/object';
import { scrollTo } from '@utils/scroll';
import ShellBody from '@components/ShellBody';
import ShopHeader from '@shopDetails/components/ShopHeader/ExtendedMenuHeader';
import LayoutOne from '@shopDetails/components/ProductList/Layout/LayoutOne';
import Swimlanes from '@shopDetails/components/Swimlanes';
import ToastFavoriteDish from '@shopDetails/components/ToastFavoriteDish';
import {
  EXTENDED_MENU_SECTION_OFFSET,
  EXTENDED_MENU_SECTION_OFFSET_MAX,
} from '@shopDetails/constants';
import ProductListShimmer from '@shopDetails/components/ProductList/Layout/LayoutOne/components/ProductListShimmer';
import connect from './connect';

function getCurrentSection(elements) {
  const sectionId = Object.keys(elements).find(key => {
    const rect = elements[key].getBoundingClientRect();
    return (
      rect.top < EXTENDED_MENU_SECTION_OFFSET_MAX &&
      rect.bottom > EXTENDED_MENU_SECTION_OFFSET
    );
  });

  return !isNullOrUndefined(sectionId) ? Number(sectionId) : null;
}

class ShopDetailsExtended extends React.Component {
  elements = {};

  componentDidMount() {
    const {
      checkJokerCartItemsQuantity,
      fetchMeasurementUnitsList,
      businessType,
      fetchPreferredDishes,
      isUserLogged,
      isFetchingPreferredDishes,
    } = this.props;
    checkJokerCartItemsQuantity();
    if (this.context) this.context.addEventListener('scroll', this.onScroll);

    if (businessType === BUSINESS_TYPE.GROCERIES) fetchMeasurementUnitsList();

    if (isUserLogged && !isFetchingPreferredDishes) {
      fetchPreferredDishes();
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedSection, menu, togglePickup } = this.props;

    if (menu && !prevProps.menu)
      this.context.addEventListener('scroll', this.onScroll);
    if (prevProps.selectedSection !== selectedSection)
      this.scrollToSection(selectedSection);
    if (togglePickup !== prevProps.togglePickup) {
      this.elements = {};
    }
  }

  componentWillUnmount() {
    this.context.removeEventListener('scroll', this.onScroll);
  }

  scrollToSection(selectedSection) {
    if (!isNullOrUndefined(selectedSection)) {
      const mostVisibleSection = getCurrentSection(this.elements);

      if (mostVisibleSection !== selectedSection) {
        let { pageYOffset: top } = this.context;
        const sectionRef = this.elements[selectedSection];
        if (sectionRef)
          top = sectionRef.offsetTop - EXTENDED_MENU_SECTION_OFFSET;
        this.context.removeEventListener('scroll', this.onScroll);
        scrollTo({ top });
        setTimeout(
          () => this.context.addEventListener('scroll', this.onScroll),
          300,
        );
      }
    }
  }

  onScroll = () => {
    const { menu, selectedSection, extendedMenuSectionChanged } = this.props;

    if (menu?.sections?.length > 0) {
      const mostVisibleSection = getCurrentSection(this.elements);
      if (
        !isNullOrUndefined(mostVisibleSection) &&
        mostVisibleSection !== selectedSection
      ) {
        extendedMenuSectionChanged(mostVisibleSection);
      }
    }
  };

  getRefsForMenuNavigation = (id, element) => {
    if (!this.elements[id]) {
      this.elements[id] = element;
    }
  };

  render() {
    const {
      shop,
      menu,
      isFetchingMenu,
      countryCode,
      hasToValidateAge,
      showShimmer,
      selectedSection,
      subHeader,
      footer,
      goTo,
      onBeforeProductConfig,
      onGoBack,
      openAgeValidation,
      trackProductSearch,
      extendedMenuSectionChanged,
    } = this.props;

    return (
      <>
        <ShellBody>
          <ShopHeader
            goBack={onGoBack}
            subHeader={subHeader}
            shop={shop}
            goTo={goTo}
          />
          {showShimmer ? (
            <ProductListShimmer />
          ) : (
            <>
              <Swimlanes
                onBeforeProductConfig={onBeforeProductConfig}
                getRefs={this.getRefsForMenuNavigation}
              />
              <LayoutOne
                menu={menu}
                isFetchingMenu={isFetchingMenu}
                onBeforeProductConfig={onBeforeProductConfig}
                openAgeValidation={openAgeValidation}
                hasToValidateAge={hasToValidateAge}
                countryCode={countryCode}
                trackProductSearch={trackProductSearch}
                selectedSection={selectedSection}
                changeSection={extendedMenuSectionChanged}
                getRefs={this.getRefsForMenuNavigation}
              />
              <ToastFavoriteDish />
            </>
          )}
        </ShellBody>
        {footer}
      </>
    );
  }
}

ShopDetailsExtended.contextType = WindowContext;

ShopDetailsExtended.propTypes = {
  // data
  countryCode: PropTypes.string.isRequired,
  isFetchingMenu: PropTypes.bool.isRequired,
  selectedSection: PropTypes.number,
  businessType: PropTypes.string,
  isUserLogged: PropTypes.bool.isRequired,
  isFetchingPreferredDishes: PropTypes.bool,
  togglePickup: PropTypes.bool,

  // WithShopDetails
  hasToValidateAge: PropTypes.bool.isRequired,
  showShimmer: PropTypes.bool.isRequired,
  onGoBack: PropTypes.func.isRequired,
  onBeforeProductConfig: PropTypes.func.isRequired,
  openAgeValidation: PropTypes.func.isRequired,
  footer: PropTypes.node,
  subHeader: PropTypes.node,
  shop: PropTypes.object,
  menu: PropTypes.object,

  // callbacks
  trackProductSearch: PropTypes.func.isRequired,
  extendedMenuSectionChanged: PropTypes.func.isRequired,
  fetchMeasurementUnitsList: PropTypes.func.isRequired,
  fetchPreferredDishes: PropTypes.func.isRequired,

  // WithJoker
  goTo: PropTypes.string,
  checkJokerCartItemsQuantity: PropTypes.func,
};

ShopDetailsExtended.defaultProps = {
  checkJokerCartItemsQuantity: () => {},
};

export default connect(ShopDetailsExtended);
